export default {
    messages: {
        ui: {
            "blockTunes": {
                "toggler": {
                    "Click to tune": "클릭 또는 드래그",
                    "or drag to move": "혹은 끌어서 이동"
                },
            },
            "inlineToolbar": {
                "converter": {
                    "Convert to": "변환"
                },
            },
            "toolbar": {
                "toolbox": {
                    "Add": "추가"
                }
            },
            "popover": {
                "Filter": "검색",
                "Nothing found": "결과 없음",
                "Convert to": "변환"
            }
        },
        toolNames: {
            "Columns": '칼럼',
            "Text": "텍스트",
            "Strikethrough": "취소선",
            "Heading": "제목",
            "List": "목록",
            "Unordered List": "일반 목록",
            "Ordered List": "순서 목록",
            "Quote": "인용",
            "Delimiter": "가로줄",
            "Table": "테이블",
            "Marker": "형광펜",
            "Underline": "밑줄",
            "Link": "링크",
            "Bold": "굵게",
            "Italic": "기울림",
            "Image": "이미지",
            "Video": "비디오",
            "InlineCode": "인라인 코드",
            "Raw HTML": "HTML 삽입",
            "Code": "글 박스",
            "ColorPicker": "글자 색",
            "Button": "버튼",
            "ShikiCodeTool": "코드 하이라이트"
        },

        tools: {
            // "warning": { // <-- 'Warning' tool will accept this dictionary section
            //   "Title": "경고",
            //   "Message": "Сообщение",
            // },
            //
            // /**
            //  * Link is the internal Inline Tool
            //  */
            // "link": {
            //   "Add a link": "링크 추가"
            // },
            // /**
            //  * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
            //  */
            // "stub": {
            //   'The block can not be displayed correctly.': '블럭을 정상적으로 표시할 수 없습니'
            // }
            "columns": {
                "Config": "칼럼 설정",
                "Style Column 1": "1열 스타일",
                "Style Column 2": "2열 스타일",
                "Style Column 3": "3열 스타일",
                "1 Column": "1열로 변경",
                "2 Columns": "2열로 변경",
                "3 Columns": "3열로 변경",
                "Roll Columns": "열 순서 바꾸기",
                "Are you sure?": "정말로 삭제하시겠어요?",
                "This will delete last Column!": "진행하면 마지막 열이 삭제됩니다.",
                "This will delete last 1 Column!": "진행하면 마지막 1열이 삭제됩니다.",
                "This will delete last 2 Column!": "진행하면 마지막 2열이 삭제됩니다.",
                "Yes, delete it!": "네, 삭제할게요",
                "Cancel": "취소",
                "Column Gap": "열 간격",
                "Column Ratio": "열 너비 비율",
                "Column Ratio 1": "1열",
                "Column Ratio 2": "2열",
                "Column Ratio 3": "3열",
                "Reset": "스타일 초기화"
            },
            "header": {
                "Heading 2": "제목 2",
                "Heading 3": "제목 3",
                "Heading 4": "제목 4",
            },
            "image": {
                "Select an Image": "클릭해서 이미지를 올려주세요",
                "Stretch image": "이미지를 넓히기",
                "With border": "테두리 추가",
                "With background": "크기 조절",
                "Without Gap": "상하 여백 제거",
                "Add link": "클릭하기 링크 추가",
                "Couldn’t upload image. Please try another.": "올릴 수 없는 이미지 입니다.",
                "Loaded invalid image URL.": "업로드할 수 없는 형식의 이미지 주소입니다. 붙여넣기 하신 경우, 참조 가능한 이미지 주소가 복사 되도록 해주세요."
            },
            "list": {
                "Unordered": "일반 목록",
                "Ordered": "순서 목록",
                "Start with": "순서 시작 값",
                "Counter type": "순서 종류",
                "Numeric": "숫자",
                "Lower Roman": "로마지 소문자",
                "Upper Roman": "로마지 대문자",
                "Lower Alpha": "알파벳 소문자",
                "Upper Alpha": "알파벳 대문자",
            },
            "code": {
                "Enter a code": "내용을 입력하세요. (박스 크기는 컨텐츠에 맞추어서 설정 됩니다)"
            },
            "linkTool": {
                "Couldn't fetch the link data": "해당 링크는 정보를 가져올 수 없습니다. 오타가 없는지 확인해주세요.",
                "Link": "URL을 입력하세요. (https:// 포함)"
            },
            "embed": {
                "Enter a caption": "내용을 입력하세요. (박스 크기는 컨텐츠에 맞추어서 설정 됩니다)"
            },
            "AnyButton": {
                'Button Text': '버튼의 내용을 입력하세요.',
                'Link Url': '버튼의 URL을 입력하세요. (https:// 포함)',
                'Set': "확인",
                'Default Button': "클릭",
                'Edit': "수정",
                'Text Color': "글자색",
                'Background Color': "배경색",
            },
            "table": {
                "Add column to left": "왼쪽에 열 추가",
                "Add column to right": "오른쪽에 열 추가",
                "Delete column": "열 삭제하기",
                "Add row above": "윗쪽에 행 추가",
                "Add row below": "아랫쪽에 행 추가",
                "Delete row": "행 삭제하기",
                "With headings": "제목 행 스타일 사용",
                "Without headings": "제목 행 스타일 제거"
            },
            "quote": {
                "Align Left": "왼쪽 정렬",
                "Align Center": "가운데 정렬",
            },
            convertTo: {
                "Convert to": "변환",
            }
        },
        blockTunes: {
            "delete": {
                "Delete": "삭제",
                "Click to delete": "정말 삭제하기"
            },
            "moveUp": {
                "Move up": "위로 이동"
            },
            "moveDown": {
                "Move down": "아래로 이동"
            },
            "duplicate": "복제하기"
        },
    }
}